// extracted by mini-css-extract-plugin
export default {"whitelabel":"WhiteLabel_whitelabel__bcbPJ"};